import React from 'react';
import { parseContentFields, getFieldDataByKey } from '../../helpers/parser';

const SpaceBlock = (props) => {
  const { contentFields } = props;
  const blockFields = parseContentFields(contentFields);
  const { units } = getFieldDataByKey(blockFields, 'Units.data', 4);

  return (
    <div style={{ margin: `${(units * 4)}px 0px`, width: '100%' }}>&nbsp;</div>
  )
};

export default SpaceBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/SpaceBlock.js